<template>
  <div>
    <div class="pa-0 ma-0 body-1 white--text">
      <div class="d-flex flex-row justify-space-between">
        <div>Actual :</div>
        <div>{{summary.actual}}</div>
      </div>
    </div>
    <div class="pl-1">                            
      <div class="pa-0 ma-0" v-for="(task, index) in summary.actualTasks" :key="index">
        <div class="d-flex flex-row justify-space-between">
          <div>{{task.title}}:</div>
          <div>{{task.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuSummary',
  props: [
    'summary'
  ]
}
</script>



// WEBPACK FOOTER //
// MenuSummary.vue?626dd798